export const fetchResponseHandler = async (response) => {
    if (!response.ok) {
        let errorData;

        try {
            // Attempt to parse error response as JSON
            errorData = await response.json();
        } catch {
            // If not JSON, get the response as text
            errorData = {
                message: await response.text(),
            };
        }

        const error = new Error(errorData.message || 'Unexpected Error');
        error.statusCode = errorData.status_code || errorData.statusCode || response.status;
        error.data = errorData.data || errorData;
        // The API path that answered, so error reporting can tell which endpoint rejected.
        // Path only: the query string can carry tokens. A constructed `Response` has no URL.
        if (response.url) {
            error.requestPath = new URL(response.url).pathname;
        }

        throw error;
    }

    // Handle successful responses
    const contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/json')) {
        return response.json();
    }

    // Fallback to text for non-JSON responses
    return response.text();
}